import { useMemo } from 'react';

export default (arr: string[]) => {
  const joinedIds = arr ? arr.join(',') : arr;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => arr, [joinedIds]);
};
